import React from 'react';
import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const WidgetBarIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <g fill="#444" transform="scale(0.0234375 0.0234375)"><path d="M470 384h128v128h-128v-128zM470 554h128v300h-128v-300zM682 554h128v86h-128v-86zM682 682h128v172h-128v-172zM256 214h128v170h-128v-170zM256 426h128v428h-128v-428z" /></g>
  </SvgIcon>;
};
